import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import Betslip from '@xanadu/ui-shared/components/betslip/Betslip';
import Multiples from '@xanadu/ui-shared/components/Multiples';
import FuturesBetslip from '@xanadu/ui-shared/components/betslip/FuturesBetslip';
import { isFuturesOrPredictionsProduct } from '@xanadu/ui-shared/modules/application/selectors';
import Search from '@xanadu/ui-shared/components/Search';

import IconMultiples from '../../../../images/icons/misc/icon-multiples.svg';
import IconBetslip from '../../../../images/icons/misc/icon-betslip.svg';
import IconSearch from '../../../../images/icons/misc/search.svg';

import styles from './Sidebar.module.scss';
import SearchResults from '../SearchResults';

const Sidebar = ({
  sidebarContent,
  sidebarVisible,
  availableFeatures,
  isFuturesOrPredictions,
}) => {
  const getItems = () => {
    const items = {
      betslip: {
        icon: (
          <IconBetslip />
        ),
        component: (
          <Fragment>
            {isFuturesOrPredictions ? (
              <FuturesBetslip withOrderPad={false} position="static" />
            ) : (
              <Betslip showPlaceTab={false} />
            )}
          </Fragment>
        ),
        name: 'My Bets',
        hook: 'rhsmybets',
      },
      search: {
        icon: (
          <IconSearch />
        ),
        component: (
          <Fragment>
            <Search
              onInputFocusChange={() => { }}
            />
            <SearchResults isMobile onSearchResultClick={() => { }} />
          </Fragment>
        ),
        name: 'Search',
        hook: 'rhssearch',
      },
    };

    if (availableFeatures.includes('multiples')) {
      items.multiples = {
        icon: (
          <IconMultiples
            className={styles.buttonIcon}
            onClick={e => e.preventDefault()}
          />
        ),
        component: (
          <Multiples
            sizeTab="small"
          />
        ),
        name: 'Multiples',
        hook: 'rhsmultiples',
      };
    }

    return items;
  };

  const getComponent = content => (getItems()[content] ? getItems()[content].component : null);

  const panelComponent = getComponent(sidebarContent);

  const mainClasses = classNames({
    [styles.main]: true,
  });

  let panel = null;

  if (sidebarVisible) {
    panel = (
      <CSSTransition
        key={sidebarContent}
        classNames={{
          enter: styles['content--enter'],
          enterActive: styles['content--enter-active'],
          enterDone: styles['content--enter-done'],
          exit: styles['content--exit'],
          exitActive: styles['content--exit-active'],
          exitDone: styles['content--exit-done'],
        }}
        timeout={300}
      >
        <div className={styles.content} data-hook="sidebar-panel-container">
          {panelComponent}
        </div>
      </CSSTransition>
    );
  }

  return (
    <div className={mainClasses}>
      <TransitionGroup component="span">
        {panel}
      </TransitionGroup>
    </div>
  );
};

Sidebar.propTypes = {
  sidebarContent: PropTypes.string,
  isFuturesOrPredictions: PropTypes.bool.isRequired,
  sidebarVisible: PropTypes.bool.isRequired,
  availableFeatures: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  return {
    sidebarContent: state.getIn(['local', 'sidebar', 'content']),
    sidebarVisible: state.getIn(['local', 'sidebar', 'visible']),
    isFuturesOrPredictions: isFuturesOrPredictionsProduct(state),
  };
}

export const Component = Sidebar;

export default connect(mapStateToProps, {})(Sidebar);
